import React from "react";
import StyledCardSection from "./styles";
import Card from "../Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import parse from "html-react-parser";

export default function CardSection({ textContent, imageContent }) {
  const mappedCards = textContent?.smallCards?.map((data, i) => {
    const { title, links, content, expandableItems } = data; // ✅ include expandableItems
    return (
      <Card
        key={title + i}
        smallHeaderImage={imageContent?.cardHeaderSmall}
        bigHeaderImage={imageContent?.cardHeaderBig}
        title={title}
        links={links}
        content={content}
        expandableItems={expandableItems} // ✅ pass this to Card
        cardSize="small"
        sm={12}
        md={6}
        lg={6}
        xl={4}
      />
    );
  });
  return (
    <StyledCardSection $imageContent={imageContent}>
      <Container className="xxl-max-width">
        <Row className="text-center">
          <Col>
            <h4 className="title">{parse(textContent?.titleOne || "")}</h4>
          </Col>
        </Row>
        <Row className="smallCards position-relative d-flex justify-content-center">
          {mappedCards}
        </Row>
        <Row className="bigCards d-flex justify-content-center my-0 mt-xl-5 mb-xl-3">
          <Card
            smallHeaderImage={imageContent?.cardHeaderSmall}
            bigHeaderImage={imageContent?.cardHeaderBig}
            title={textContent?.bigCards?.dpa?.title}
            // links={textContent?.bigCards?.dpa?.links}
            content={textContent?.bigCards?.dpa?.content}
            cardSize="big"
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
          />
        </Row>
        <Row className="text-center">
          <Col>
            <h4 className="title">{parse(textContent?.titleTwo || "")}</h4>
          </Col>
        </Row>
        <Row className="bigCards d-flex justify-content-center">
          <Card
            smallHeaderImage={imageContent?.cardHeaderSmall}
            bigHeaderImage={imageContent?.cardHeaderBig}
            title={textContent?.bigCards?.hecm?.title}
            links={textContent?.bigCards?.hecm?.links}
            content={textContent?.bigCards?.hecm?.content}
            cardSize="big"
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
          />
        </Row>
        <Row className="d-flex justify-content-center">
          <Col>
            <p className="bottomLine">{parse(textContent?.bottomLine || "")}</p>
          </Col>
        </Row>
      </Container>
    </StyledCardSection>
  );
}
